var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _awaitAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var getIterator = require('get-iterator');

var AbortError = require('./AbortError'); // Wrap an iterator to make it abortable, allow cleanup when aborted via onAbort


var toAbortableSource = function toAbortableSource(source, signal, options) {
  return toMultiAbortableSource(source, Array.isArray(signal) ? signal : [{
    signal: signal,
    options: options
  }]);
};

var toMultiAbortableSource = function toMultiAbortableSource(source, signals) {
  source = getIterator(source);
  signals = signals.map(function (_ref) {
    var signal = _ref.signal,
        options = _ref.options;
    return {
      signal: signal,
      options: options || {}
    };
  });

  function abortable() {
    return _abortable.apply(this, arguments);
  }

  function _abortable() {
    _abortable = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var nextAbortHandler, abortHandler, _iterator, _step, _signal2, result, _iterator2, _step2, _step2$value, signal, options, abortMessage, abortCode, abort, _iterator3, _step3, _signal, aborter, isKnownAborter, _iterator4, _step4, _signal3;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              abortHandler = function abortHandler() {
                if (nextAbortHandler) nextAbortHandler();
              };

              _iterator = _createForOfIteratorHelper(signals);

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  _signal2 = _step.value.signal;

                  _signal2.addEventListener('abort', abortHandler);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }

            case 3:
              if (!true) {
                _context.next = 52;
                break;
              }

              result = void 0;
              _context.prev = 5;
              _iterator2 = _createForOfIteratorHelper(signals);
              _context.prev = 7;

              _iterator2.s();

            case 9:
              if ((_step2 = _iterator2.n()).done) {
                _context.next = 16;
                break;
              }

              _step2$value = _step2.value, signal = _step2$value.signal, options = _step2$value.options;

              if (!signal.aborted) {
                _context.next = 14;
                break;
              }

              abortMessage = options.abortMessage, abortCode = options.abortCode;
              throw new AbortError(abortMessage, abortCode);

            case 14:
              _context.next = 9;
              break;

            case 16:
              _context.next = 21;
              break;

            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](7);

              _iterator2.e(_context.t0);

            case 21:
              _context.prev = 21;

              _iterator2.f();

              return _context.finish(21);

            case 24:
              abort = new Promise(function (resolve, reject) {
                nextAbortHandler = function nextAbortHandler() {
                  var _signals$find = signals.find(function (_ref2) {
                    var signal = _ref2.signal;
                    return signal.aborted;
                  }),
                      options = _signals$find.options;

                  var abortMessage = options.abortMessage,
                      abortCode = options.abortCode;
                  reject(new AbortError(abortMessage, abortCode));
                };
              }); // Race the iterator and the abort signals

              _context.next = 27;
              return _awaitAsyncGenerator(Promise.race([abort, source.next()]));

            case 27:
              result = _context.sent;
              nextAbortHandler = null;
              _context.next = 46;
              break;

            case 31:
              _context.prev = 31;
              _context.t1 = _context["catch"](5);
              _iterator3 = _createForOfIteratorHelper(signals);

              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  _signal = _step3.value.signal;

                  _signal.removeEventListener('abort', abortHandler);
                } // Might not have been aborted by a known signal

              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }

              aborter = signals.find(function (_ref3) {
                var signal = _ref3.signal;
                return signal.aborted;
              });
              isKnownAborter = _context.t1.type === 'aborted' && aborter;

              if (!(isKnownAborter && aborter.options.onAbort)) {
                _context.next = 40;
                break;
              }

              _context.next = 40;
              return _awaitAsyncGenerator(aborter.options.onAbort(source));

            case 40:
              if (!(typeof source.return === 'function')) {
                _context.next = 43;
                break;
              }

              _context.next = 43;
              return _awaitAsyncGenerator(source.return());

            case 43:
              if (!(isKnownAborter && aborter.options.returnOnAbort)) {
                _context.next = 45;
                break;
              }

              return _context.abrupt("return");

            case 45:
              throw _context.t1;

            case 46:
              if (!result.done) {
                _context.next = 48;
                break;
              }

              return _context.abrupt("break", 52);

            case 48:
              _context.next = 50;
              return result.value;

            case 50:
              _context.next = 3;
              break;

            case 52:
              _iterator4 = _createForOfIteratorHelper(signals);

              try {
                for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                  _signal3 = _step4.value.signal;

                  _signal3.removeEventListener('abort', abortHandler);
                }
              } catch (err) {
                _iterator4.e(err);
              } finally {
                _iterator4.f();
              }

            case 54:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[5, 31], [7, 18, 21, 24]]);
    }));
    return _abortable.apply(this, arguments);
  }

  return abortable();
};

var toAbortableSink = function toAbortableSink(sink, signal, options) {
  return toMultiAbortableSink(sink, Array.isArray(signal) ? signal : [{
    signal: signal,
    options: options
  }]);
};

var toMultiAbortableSink = function toMultiAbortableSink(sink, signals) {
  return function (source) {
    return sink(toMultiAbortableSource(source, signals));
  };
};

var toAbortableDuplex = function toAbortableDuplex(duplex, signal, options) {
  return toMultiAbortableDuplex(duplex, Array.isArray(signal) ? signal : [{
    signal: signal,
    options: options
  }]);
};

var toMultiAbortableDuplex = function toMultiAbortableDuplex(duplex, signals) {
  return {
    sink: toMultiAbortableSink(duplex.sink, signals),
    source: toMultiAbortableSource(duplex.source, signals)
  };
};

module.exports = toAbortableSource;
module.exports.AbortError = AbortError;
module.exports.source = toAbortableSource;
module.exports.sink = toAbortableSink;
module.exports.transform = toAbortableSink;
module.exports.duplex = toAbortableDuplex;